<app-header></app-header>

<section id="equipo-int" class="bg-light reset-section-pad2">

    <div class="container" data-aos="fade-right" data-aos-duration="1500">

          <div class="row" >
             <div class="col-lg-12 mb-4">
                   <h1 class="fw-bold">ACCESIBILIDAD</h1>
                 
             </div>   
         </div>


          <div class="row" >
             <div class="col-lg-12 mb-5">
                  
                  <p>Retailcompany 2021, S.L., (“RetailCo”) quiere facilitar a sus usuarios el máximo nivel de accesibilidad a los contenidos de su web <a href="https://www.retailco.es">www.retailco.es</a>. Para ello, RetailCo está trabajando en el desarrollo y mantenimiento de su web conforme a las directrices de accesibilidad definidas por el grupo de trabajo [Web Accessibility Initiative (WAI), del Consorcio para la World Wide Web (W3C), en su nivel AA].</p>
                  <p>En esta línea, RetailCo ha adoptado las siguientes medidas:</p>
                  <ul>
                    <li>Tamaño del texto. Las fuentes utilizadas tienen dimensiones relativas, de forma que el usuario puede controlar su tamaño desde el navegador que esté utilizando.</li>
                    <li>Diseño, navegación e interactividad. Se ha tratado de conseguir una navegación coherente en todo el sitio web, siguiendo los mismos esquemas estructurales en todas las páginas. El color y contraste de los elementos están pensados para que puedan ser apreciados correctamente por todos los usuarios.</li>
                    <li>Interpretación de recursos gráficos. Las imágenes, banners y tablas publicadas en la web incorporan una descripción que facilita la comprensión de la información contenida en estos recursos gráficos.</li>
                    <li>Enlaces. La mayoría de los enlaces de la web incorporan una aclaración sobre su destino y aportan información sobre si se van a desplegar en una nueva ventana.</li>
                    <li>Navegadores que no soportan CSS (Cascading Style Sheets), Javascript, plugins. En caso de que el usuario acceda al portal a través de un navegador que no soporte CSS, el marcado estructural permite la correcta visualización de todos los contenidos. Por otro lado, se han incorporado contenidos alternativos a películas flash, y applets de java.</li>
                  </ul>
                  <p>En la aplicación de estas medidas, RetailCo ha tenido en cuenta: </p>
                  <ul>
                    <li>Normas WCAG (Web Content Accessibility Guidelines) del W3C (World Wide Web Consortium), en su nivel intermedio (AA). Pautas de Contenido Accesible en Web 2.0.</li>
                    <li>Recomendación del W3C sobre las Hojas de Estilo en Cascada, Nivel 2 (CSS 2.1). </li>
                    <li>Estándar recomendado en empleo de código HTML verificando las recomendaciones XHTML 1.0 Transitional.</li>
                  </ul>  
             </div>   
         </div>

             <div class="row" >
             <div class="col-lg-12 mb-5">
                  <h2>Contacto</h2>
                  <p>Si usted encuentra algún tipo de dificultad de accesibilidad o usabilidad en su visita al Portal o quiere hacernos alguna sugerencia al respecto, puede hacerlo a través de la siguiente dirección de email: <a href="mailto:info@retailco.es">info@retailco.es</a>. Su opinión contribuirá a la progresiva mejora del Portal.</p>
                
             </div>   
         </div>




     </div><!-- fin container-->

</section>

<app-footer-main></app-footer-main>